import gql from 'graphql-tag'

export default {
  service() {
    return {
      query: gql`
        query Query($serviceId: ID!) {
          service(id: $serviceId) {
            id
            status
            total_price
            customer_reference
            install_charge
            active_contract {
              id
              contract_end
            }
            delivery_method {
              id
              reference
              type
            }
            location {
              id
              business_name
              premise {
                id
                address
                primary_upstream {
                  id
                  site_code
                }
              }
            }
            product {
              id
              product_reference
              service_reference
            }
            account {
              id
              name
            }
            plan {
              id
              speed
              contract_length
            }
            handoff {
              id
              service_delivery_port
              service_delivery_port_vlan
              service_delivery_port_speed
              service_delivery_port_medium
              ip_address_type
              ip_address
              subnet_mask
              default_gateway
              x_connect_end
              delivered_to_type
              delivered_to_id
              delivered_to_vlan
              x_connect_a_end_reference
              x_connect_z_end_reference
            }
          }
        }
      `,
      variables() {
        return {
          serviceId: this.$route.params.id
        }
      }
    }
  }
}
